import axios from 'axios';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { apiUrl } from '@/utility/axios';
import { getLoginParentUser } from '@/utility/parent-login';

export const parentLogin = 'parent-login';
export const parentViewerSetting = 'parent-viewer-setting';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/',
    meta: { isPublic: true, title: 'ほいくむ(保護者)' },
    component: () => import(/* webpackChunkName: "parent-frame" */ '../views/Parent/ParentFrame.vue'),
    children: [
      {
        path: '',
        name: '',
        meta: { isPublic: true },
        component: () => import(/* webpackChunkName: "parent-login" */ '../views/Parent/ParentLogin.vue'),
      },
      {
        path: 'login',
        name: parentLogin,
        meta: { isPublic: true },
        component: () => import(/* webpackChunkName: "parent-login" */ '../views/Parent/ParentLogin.vue'),
      },
      {
        path: 'reset-pw',
        name: 'parent-reset-pw',
        meta: { isPublic: true },
        component: () => import(/* webpackChunkName: "parent-reset-pw" */ '../views/Parent/ParentResetPw.vue'),
      },
      {
        path: 'set-pw/:id',
        name: 'parent-set-pw',
        meta: { isPublic: true },
        component: () => import(/* webpackChunkName: "parent-set-pw" */ '../views/Parent/ParentSetPw.vue'),
      },
      {
        path: 'home',
        name: 'parent-home',
        component: () => import(/* webpackChunkName: "parent-home" */ '../views/Parent/ParentHome.vue'),
      },
      {
        path: 'news/:infono(\\d+)',
        name: 'parent-news',
        component: () => import(/* webpackChunkName: "parent-news" */ '../views/Parent/ParentNews.vue'),
      },
      {
        path: 'news-single/:infono(\\d+)',
        name: 'parent-news-single',
        component: () => import(/* webpackChunkName: "parent-news-single" */ '../views/Parent/ParentNewsSingle.vue'),
      },
      {
        path: 'input-schedule',
        name: 'parent-input-schedule',
        component: () => import(/* webpackChunkName: "parent-input-schedule" */ '../views/Parent/ParentInputSchedule.vue'),
      },
      {
        path: 'input-schedule/:yyyymm',
        name: 'parent-input-schedule-monthly',
        component: () => import(/* webpackChunkName: "parent-input-schedule-monthly" */ '../views/Parent/ParentInputSchedule.vue'),
      },
      {
        path: 'display-schedule/:pageType',
        name: 'parent-display-schedule',
        component: () => import(/* webpackChunkName: "parent-display-schedule" */ '../views/Parent/ParentDisplaySchedule.vue'),
      },
      {
        path: 'ric-diary',
        name: 'parent-ric-diary',
        component: () => import(/* webpackChunkName: "parent-ric-diary" */ '../views/Parent/RicDiary/ParentRicDiary.vue'),
      },
      {
        path: 'ric-diary-list/:fav(\\d+)',
        name: 'parent-ric-diary-list',
        component: () => import(/* webpackChunkName: "parent-ric-diary-list" */ '../views/Parent/RicDiary/ParentRicDiaryList.vue'),
      },
      {
        path: 'ric-diary-post/:fav(\\d+)/:no(\\d+)',
        name: 'parent-ric-diary-post',
        component: () => import(/* webpackChunkName: "parent-ric-diary-post" */ '../views/Parent/RicDiary/ParentRicDiaryPost.vue'),
      },
      {
        path: 'photo/:ym?',
        name: 'parent-photo',
        component: () => import(/* webpackChunkName: "parent-photo" */ '../views/Parent/Photo/ParentPhoto.vue'),
      },
      {
        path: 'photo-detail/:no(\\d+)/:ym',
        name: 'parent-photo-detail',
        component: () => import(/* webpackChunkName: "parent-photo-detail" */ '../views/Parent/Photo/ParentPhotoDetail.vue'),
      },

      {
        path: 'withdrawal',
        name: 'parent-withdrawal',
        component: () => import(/* webpackChunkName: "parent-withdrawal" */ '../views/Parent/Withdrawal/ParentWithdrawal.vue'),
      },
      {
        path: 'withdrawal-detail/:no(\\d+)',
        name: 'parent-withdrawal-detail',
        component: () => import(/* webpackChunkName: "parent-withdrawal-detail" */ '../views/Parent/Withdrawal/ParentWithdrawalDetail.vue'),
      },
      {
        path: 'setting',
        name: 'parent-setting',
        component: () => import(/* webpackChunkName: "parent-setting" */ '../views/Parent/ParentSetting.vue'),
      },
      {
        path: 'viewer-setting',
        name: parentViewerSetting,
        component: () => import(/* webpackChunkName: "parent-viewer-setting" */ '../views/Parent/ParentViewerSetting.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title as string) ?? 'ほいくむ';

  //  アクセスログ送信
  const loginUser = getLoginParentUser();
  if (loginUser) {
    axios.post(`${apiUrl}/accesslogs/log`, {
      accessRouteName: to.name as string,
      accessRouteParams: JSON.stringify(to.params),
    });
  }

  if (to.matched.some(record => !record?.meta.isPublic) && !loginUser) {
    const head = to.matched[0].path.replace('/', '');
    const name = head + '-' + 'login';
    next({ name: name, query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
